import { __awaiter } from 'tslib';
import { getCreatorsRecaptchaToken } from '../recaptcha.js';
import { isLocalStorageSupported, getDeviceName } from '../utils.js';

const ENDPOINT = 'authenticate';
const dashboardAuthenticate = (gateway, params) => __awaiter(void 0, void 0, void 0, function* () {
    let token;
    let lang = 'en';
    if (isLocalStorageSupported) {
        lang = localStorage.getItem('userlanguageprod') || 'en';
    }
    try {
        token = yield getCreatorsRecaptchaToken('authenticate');
    }
    catch (error) { }
    const finalParams = Object.assign(Object.assign({}, params), { output: 'jsonhp', devicename: getDeviceName(), re_token: token, dashboardaccess: 'yes', timeout: 25000, lang: lang, language: lang, m: 'an', v: '1.0.0', set_cookies: 1 });
    return gateway
        .post(dashboardAuthenticate.endpoint, Object.assign(Object.assign({}, params), { re_token: token }), finalParams)
        .then((response) => {
        if (!(response === null || response === void 0 ? void 0 : response.data)) {
            throw new Error(`Failed Api statusText: ${response.statusText} (${response.status}) ${response['message']} - No data returned`);
        }
        if (response.data.authenticate) {
            // store only the basic user info
            gateway.authenticationResponse = response.data;
            gateway.setTokens({
                socketsessionid: response.data.authenticate.socketsessionid
                    ? response.data.authenticate.socketsessionid
                    : response.data.authenticate._attributes.socketsessionid
            });
        }
        return response;
    });
});
dashboardAuthenticate.endpoint = ENDPOINT;
var PlanTypes;
(function (PlanTypes) {
    PlanTypes[PlanTypes["FREE"] = 1] = "FREE";
    PlanTypes[PlanTypes["FREEMIUM"] = 2] = "FREEMIUM";
    PlanTypes[PlanTypes["PLUS"] = 3] = "PLUS";
    PlanTypes[PlanTypes["WAVO"] = 4] = "WAVO";
    PlanTypes[PlanTypes["WAJEEZ"] = 5] = "WAJEEZ";
    PlanTypes[PlanTypes["NO_ADS"] = 6] = "NO_ADS";
    PlanTypes[PlanTypes["GOLD"] = 7] = "GOLD";
})(PlanTypes || (PlanTypes = {}));

export { PlanTypes, dashboardAuthenticate };
//# sourceMappingURL=authentication.js.map
